import type { PopupContextType } from "./types"

/** 全局 Popup API，避免 Context 因模块重复实例导致 usePopup 找不到 Provider */
let popupApi: PopupContextType | null = null
const pendingTasks: Array<(api: PopupContextType) => void> = []

function flushPending() {
  if (!popupApi) return
  while (pendingTasks.length > 0) {
    const task = pendingTasks.shift()
    task?.(popupApi)
  }
}

export const popupBridge = {
  register(api: PopupContextType) {
    popupApi = api
    flushPending()
  },
  unregister(api?: PopupContextType) {
    if (!api || popupApi === api) {
      popupApi = null
    }
  },
  get(): PopupContextType | null {
    return popupApi
  },
  runWhenReady(task: (api: PopupContextType) => void) {
    if (popupApi) task(popupApi)
    else pendingTasks.push(task)
  },
}
